import { useEffect } from 'react';
import { initializeGA, trackPageView } from '../utils/analytics';

export default function Analytics() {
  useEffect(() => {
    // Initialize GA on component mount
    initializeGA();
    
    // Track initial page view
    trackPageView(window.location.pathname + window.location.search);
    
    // Set up navigation tracking with URL encoding
    const handleRouteChange = (url: string) => {
      // Make sure the URL is safe by encoding it
      trackPageView(encodeURIComponent(url));
    };

    // Add event listener for URL changes if using client-side routing
    window.addEventListener('popstate', () => {
      handleRouteChange(window.location.pathname + window.location.search);
    });

    return () => {
      window.removeEventListener('popstate', () => {
        handleRouteChange(window.location.pathname + window.location.search);
      });
    };
  }, []);

  return null;
}